import { useTranslation } from "react-i18next";
import { PhoneOff } from "lucide-react";
import { Button } from "@tellescope/design-system";
import { useMeetingOperations } from "@tellescope/video-calling";

interface VideoCallTerminalNoticeProps {
  reason: "ended" | "cancelled" | "unavailable";
}

export const VideoCallTerminalNotice = ({ reason }: VideoCallTerminalNoticeProps) => {
  const { t } = useTranslation("videoCalling");
  const { leaveMeeting } = useMeetingOperations();

  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-4 p-6 text-center">
      <PhoneOff className="h-12 w-12 text-muted-foreground" />
      <p className="text-foreground" role="status">
        {reason === "ended"
          ? t("This call has ended")
          : reason === "cancelled"
          ? t("This appointment has been cancelled")
          : t("Unable to load event")}
      </p>
      <Button onClick={leaveMeeting}>{t("Close")}</Button>
    </div>
  );
};
